const dialog = {
  init(code, opts) {
    const handle = {
      onSure: function () {
        // alert('学习让我快乐');
        // var timeRange = $("#selectBtn ul li.selected").attr("data-value")
        // console.log(timeRange)
        opts.onSure && opts.onSure()
      },
      onCancel: function () {
        opts.onCancel && opts.onCancel()
      }
    }

    const baseConfig = {
      ok: '确  认',
      closeBtn: false,
    }

    let config = {}

    if (code === 8930003 || code === 8930006) {
      let btnStr = ''
      if (code === 8930003) {
        btnStr = '继续学习'
      }

      if (code === 8930006) {
        btnStr = '查询状态'
      }

      const str = '<div class="dialog-custom-text">' +
        '<p>' + opts.msg + '</p>' +
        '</div>';

      config = Object.assign({}, baseConfig, {
        msg: str,
        ok: btnStr,
        cancel: false,
        width: 536,
        height: 356,
        closeBtn: true, //是否显示右上角关闭按钮
      }, handle)

    } else if (code === 8930004) {
      const timeList = opts.timeList
      let str = ''
      if (typeof opts.reChoose != 'undefined' && opts.reChoose) {
        if (!opts.msg) {
          str = '<p style="margin-bottom: 10px;font-size: 22px;color: #333;font-weight: 700;">哎呀，课程课时消耗完毕，快点帮我加课时吧！</p>'
        }
        str += '<p class="sq-dialog-times-title">老师建议的选项：' + opts.remark + '分钟</p>'
      } else {
        str = '<p class="sq-dialog-times-title">选择所需课时数：</p>'
      }

      let str101 = '<div class="sq-dialog-title">' +
        '<p>' + opts.msg + '</p>' +
        '</div>' +
        '<div class="sq-dialog-times">' +
        str +
        '<ul class="sq-dialog-times-list">';
      const remark = opts.remark ? opts.remark : opts.timeList[0]
      for (let i = 0; i < timeList.length; i++) {
        str101 += '<li>' +
          '<input type="radio" id="radio' + i + '" name="radio" data-value="' + timeList[i] + '" ' + `${remark === timeList[i] ? 'checked' : ''}` + '/><label for="radio' + i + '">' + timeList[i] + '分钟</label>' +
          '</li>'
      }

      str101 += '</ul>' +
        '</div>';
      config = Object.assign({}, baseConfig, {
        msg: str101,
        ok: '申请课时',
        cancel: false,
        width: 948,
        height: 660,
        pkgIcon: 'left',
        closeBtn: true, //是否显示右上角关闭按钮
        title: '申请充课时',
      }, handle)

    } else if (code === 8930005) {
      const str = '<div class="dialog-custom-text">' +
        '<p>' + opts.msg + '</p>' +
        '</div>';

      config = Object.assign({}, baseConfig, {
        msg: str,
        ok: '查询状态',
        cancel: false,
        width: 536,
        height: 356,
        closeBtn: true, //是否显示右上角关闭按钮
      }, handle)

    } else if (code === 8930007) {
      const str = '<div class="dialog-custom-text">' +
        '<p>' + opts.msg + '</p>' +
        '</div>';

      config = Object.assign({}, baseConfig, {
        msg: str,
        ok: '重新申请',
        cancel: false,
        width: 536,
        height: 356,
        closeBtn: true, //是否显示右上角关闭按钮
      }, handle)
    }
    setTimeout(() => {
      $.dialog(config)
    }, 0)
  }
}

export default dialog



// WEBPACK FOOTER //
// ./src/utils/dialog.js